export default function OpenTestIcon({ className }: { className?: string }) {
    return (
        <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={`${className} w-8 h-8`}
        >
            <path
                d="M5.36328 28.0001L25.4544 28.0001L28.9999 12.4001L8.90878 12.4001L5.36328 28.0001Z"
                stroke="currentStroke"
                strokeWidth="2"
                strokeMiterlimit="10"
                strokeLinecap="square"
            />
            <path
                d="M24.273 7.6L13.6365 7.6L11.2728 4L3 4L3 23.2"
                stroke="currentStroke"
                strokeWidth="2"
                strokeMiterlimit="10"
                strokeLinecap="square"
            />
        </svg>
    );
}
